import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from "@angular/core";
import { Params, RouterLink, RouterLinkActive } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

export interface NavLink {
  label: string;
  routerLink: string | string[] | null | undefined;
  visibilityCondition?: boolean;
  queryParams?: Params;
  icon?: string;
  subLinks?: NavLink[];
}

@Component({
  selector: "app-nav-elem",
  templateUrl: "./nav-elem.html",
  styleUrls: ["./nav-elem.scss"],
  imports: [
    RouterLink,
    RouterLinkActive,
    MatIcon,
    TranslatePipe,
    AsyncPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavElem implements OnChanges {
  @Input({ required: true }) public link!: NavLink;
  @HostBinding("style.display") public get display(): string {
    return this.link.visibilityCondition ?? true ? "flex" : "none";
  }
  @ViewChildren("subLinkElem") public subLinkElems?: QueryList<ElementRef<HTMLAnchorElement>>;
  public expanded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.["menuFolded"]?.currentValue) {
      this.expanded$.next(false);
    }
  }

  public togglePanel(): void {
    if (!this.link.subLinks?.length) {
      return;
    }
    this.expanded$.next(!this.expanded$.value);
  }

  public onMainLinkDeactivated(activated: boolean): void {
    if (!activated) {
      this.togglePanel();
    }
  }
}
